// Gemas da Wheel of Destiny (como o Gem Atelier do Tibia, simplificado): caem de bosses, são reveladas por gold
// e encaixadas num domínio da Wheel (uma por domínio). Cada gema dá bônus de atributos que somam com os do equipamento.
// Tamanhos, chances, custos e exigências abaixo são proposta.
import type { Affix, AffixKey } from './affixes.js';
import type { WheelDomain } from './wheel.js';

export type GemSize = 0 | 1 | 2;
export const GEM_NAMES = ['Lesser Gem', 'Regular Gem', 'Greater Gem'] as const;
export interface Gem { id: number; size: GemSize; domain: WheelDomain; mods: Affix[] | null }
export interface GemState { list: Gem[]; sockets: Partial<Record<WheelDomain, number>>; seq: number }
export const emptyGems = (): GemState => ({ list: [], sockets: {}, seq: 0 });

export const GEM_MAX = 60;
/** gold para revelar (abrir) uma gema */
export const GEM_REVEAL_GOLD = [20_000, 100_000, 500_000] as const;
/** vessels (fatias de encaixe cheias) exigidos no domínio para cada tamanho, como no Tibia: Lesser 1, Regular 2, Greater 3 */
export const GEM_VESSELS = [1, 2, 3] as const;
/** chance (%) de cada tamanho por boss derrotado */
export const GEM_DROP = [20, 8, 2] as const;

/** atributos que cada domínio pode dar (o domínio da gema é sorteado na queda) */
export const GEM_POOL: Record<WheelDomain, AffixKey[]> = {
  green: ['hp', 'res_earth', 'res_physical', 'lifeleech'],
  red: ['dmg', 'critdmg', 'res_fire', 'res_death'],
  blue: ['mana', 'manaleech', 'res_ice', 'res_holy'],
  purple: ['crit', 'speed', 'res_energy', 'dmg'],
};
const RANGE: Array<[number, number]> = [[0.5, 1], [0.8, 1.3], [1.2, 1.8]];

export function rollGemMods(size: GemSize, domain: WheelDomain, rnd = Math.random): Affix[] {
  const pool = [...GEM_POOL[domain]];
  const out: Affix[] = [];
  const [lo, hi] = RANGE[size]!;
  for (let i = 0; i <= size && pool.length; i++) {
    const k = pool.splice(Math.floor(rnd() * pool.length), 1)[0]!;
    out.push({ k, v: Math.round((lo + rnd() * (hi - lo)) * 10) / 10 });
  }
  return out;
}

/** atributos das gemas encaixadas (só as reveladas e com vessels suficientes no domínio) */
export function gemAffixes(g: GemState | undefined, vessels: Record<string, number>): Affix[][] {
  if (!g) return [];
  const out: Affix[][] = [];
  for (const [dom, id] of Object.entries(g.sockets)) {
    const gem = g.list.find((x) => x.id === id);
    if (gem?.mods && gem.domain === dom && (vessels[dom] ?? 0) >= GEM_VESSELS[gem.size]) out.push(gem.mods);
  }
  return out;
}
